// =====================================================================
// 📞 Clave de teléfono para comparar clientes.
// El cliente reserva siempre con el formato local (0981234567), pero en el
// panel un mismo número se puede cargar como 595981234567, +595 981 234 567
// o 981234567. Antes se comparaban los dígitos tal cual, así que un socio
// cargado con 595 no se reconocía: el turno no quedaba como de membresía
// (0 visitas usadas) y el cliente aparecía como "Nuevo" en la agenda.
// =====================================================================

// Paraguay → siempre 0 + 9 dígitos. Brasil (11 díg.) u otros quedan igual.
export const claveTelefono = (phone) => {
  const d = String(phone || '').replace(/\D/g, '');
  if (d.length === 12 && d.startsWith('5959')) return `0${d.slice(3)}`;
  if (d.length === 9 && d.startsWith('9')) return `0${d}`;
  return d;
};

// Teléfono de cliente válido: entre 8 y 15 dígitos. Ya no se exige 10 fijo
// porque hay clientes con número brasilero (11 díg. o 13 con el 55).
export const telefonoValido = (phone) => /^\d{8,15}$/.test(String(phone || '').replace(/\D/g, ''));

// Número en formato internacional para WhatsApp (wa.me / API de Meta).
// Reconoce Paraguay (0981… → 595981…) y Brasil (DDD + 9 + 8 díg. = 11 →
// 55…). Antes se le pegaba 595 a cualquier número y a los brasileros nunca
// les llegaba el mensaje. Misma lógica en functions/index.js
// (normalizarNumeroWA) — si se toca acá, hay que tocar allá también.
export const telefonoInternacional = (phone) => {
  const d = String(phone || '').replace(/\D/g, '');
  if (!d) return '';
  if (d.length === 12 && d.startsWith('595')) return d; // PY con código de país
  if (d.length === 13 && d.startsWith('55')) return d; // BR con código de país
  if (d.length === 11 && /^[1-9][1-9]9\d{8}$/.test(d)) return `55${d}`; // BR local
  if (d.startsWith('0')) return `595${d.slice(1)}`; // PY local (0981…)
  if (d.length <= 9) return `595${d}`; // PY sin el 0 (981…)
  return d; // Otro país, se asume que ya trae su código
};

export const mismoTelefono = (a, b) => {
  const ka = claveTelefono(a);
  return !!ka && ka === claveTelefono(b);
};

// Formatos en los que puede estar guardado un número paraguayo en Firestore
// (para consultas `where('clientPhone', 'in', ...)`).
export const variantesTelefono = (phone) => {
  const clave = claveTelefono(phone);
  if (!clave) return [];
  if (/^09\d{8}$/.test(clave)) return [clave, `595${clave.slice(1)}`, clave.slice(1)];
  return [clave];
};
